// @ts-nocheck
import React, { useEffect, useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { authenticationState, performSignOut, updateUserRequest } from "../store/userSlice";
import { fetchAuthSession, signInWithRedirect } from "aws-amplify/auth";
import { generateClient } from "aws-amplify/api";
import { useNavigate } from "react-router-dom";
import { getLoginAccessCodes, getUser } from "../graphql/queries";
import { modalViewsConst, setModalState } from "../store/modalSlice";
import { resetOnboarding } from "../store/onboardingSlice";
import { clearTourFlags } from "./Tour/tourFlags";
import ProfilePictureRounded from "./ProfilePictureRounded";
import TestEndpoints from "../pages/TestEndpoints";
import MyOrganizationList from "./Organization/MyOrganizationList";
import ManageProfilesSection from "./Settings/ManageProfilesSection";
import SettingsRow, { SettingsGroup } from "./Settings/SettingsRow";
import { ReactComponent as SettingsIcon } from "../assets/icons/settings.svg";
import { ReactComponent as GlobeIcon } from "../assets/icons/globe-02.svg";
import { ReactComponent as LayersIcon } from "../assets/icons/layers-icon.svg";
import { ReactComponent as ActivityIcon } from "../assets/icons/activity.svg";
import { ReactComponent as CompassIcon } from "../assets/icons/compass-03.svg";
import { ReactComponent as TargetIcon } from "../assets/icons/target-05.svg";
import { usePostHog } from "@posthog/react";
import { parseUserConsent, updateConsent } from "../utils/userConsent";
import { setUserConsent } from "../store/userSlice";
import { updateUser } from "../graphql/customMutations";
import { identifyUserForPostHog } from "../utils/posthogIdentify";
import { fetchMyPublicProfile } from "../store/publicProfileSlice";
import { PageContainer, PageHeader } from "./AssetBreadCrumb";

const defaultSignupForm = {
  email: "",
  password: "",
  confirmPassword: "",
  username: "",
  accessCode: "",
};

//needed for public access
const client = generateClient({ authMode: "identityPool" });

export const CreateAccount = ({
  onFormSubmit,
  serverSideErrors = "",
  isLoading = false,
}) => {
  const [formState, setFormState] = useState(defaultSignupForm);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordConfVisible, setPasswordConfVisible] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);

  const fetchAccessCode = async (code) => {
    try {
      const { data } = await client.graphql({
        query: getLoginAccessCodes,
        variables: {
          code,
        },
      });

      return data.getLoginAccessCodes;
    } catch (error) {
      console.log("access Code Load Error", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = [];
    if (formState.password.length < 6) {
      errors.push("password must have at least 7 characters");
    }
    if (formState.password !== formState.confirmPassword) {
      errors.push("password and confirm password do not match");
    }
    if (formState.email.trim().length === 0) {
      errors.push("you must include an email address");
    }
    if (formState.username.trim().length < 3) {
      errors.push("your username must include more than 3 characters");
    }

    // const accessCode = await fetchAccessCode(formState.accessCode); if (!accessCode) { errors.push("your access code is invalid"); }

    // if (accessCode && !accessCode.available) { errors.push("The access code you provided has already been used."); }

    setErrorMessages([...errors]);

    if (errors.length === 0) {
      onFormSubmit(formState);
    }
  };

  return (
    <form className="p-4" onSubmit={handleSubmit}>
      <div className="mb-2 text-lg">
        <div className="font-Inter font-semibold">Email</div>
        <div className="flex">
          <div className="flex-1 flex rounded border border-black">
            <input
              className="p-1 flex-1 rounded "
              type="email"
              value={formState["email"]}
              name="email"
              onChange={(e) =>
                setFormState({ ...formState, [e.target.name]: e.target.value })
              }
            ></input>
          </div>
        </div>
      </div>
      <div className="mb-2 text-lg">
        <div className="font-Inter font-semibold">Password</div>
        <div className="flex">
          <div className="flex-1 flex rounded border border-black">
            <input
              className="p-1 align-middle flex-1 rounded-l-lg"
              type={passwordVisible ? "string" : "password"}
              value={formState["password"]}
              name="password"
              onChange={(e) =>
                setFormState({ ...formState, [e.target.name]: e.target.value })
              }
            ></input>
            <button
              className="p-1 align-middle bg-white rounded-r-lg border-l-2 border-black"
              type="button"
              onClick={() => setPasswordVisible(!passwordVisible)}
            >
              {passwordVisible ? (
                <AiOutlineEyeInvisible fontSize="1.4em" />
              ) : (
                <AiOutlineEye fontSize="1.4em" />
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="mb-2 text-lg">
        <div className="font-Inter font-semibold">Confirm Password</div>
        <div className="flex">
          <div className="flex-1 flex rounded border border-black">
            <input
              className="p-1 align-middle flex-1 rounded-l-lg"
              type={passwordConfVisible ? "string" : "password"}
              value={formState["confirmPassword"]}
              name="confirmPassword"
              onChange={(e) =>
                setFormState({ ...formState, [e.target.name]: e.target.value })
              }
            ></input>
            <button
              className="p-1 align-middle bg-white rounded-r-lg border-l-2 border-black"
              type="button"
              onClick={() => setPasswordConfVisible(!passwordConfVisible)}
            >
              {passwordConfVisible ? (
                <AiOutlineEyeInvisible fontSize="1.4em" />
              ) : (
                <AiOutlineEye fontSize="1.4em" />
              )}
            </button>
          </div>
        </div>
      </div>
      <div className="mb-4 text-lg">
        <div className="font-Inter font-semibold">Username</div>
        <div className="flex">
          <div className="flex-1 flex rounded border border-black">
            <input
              className="p-1 align-middle flex-1 rounded"
              type="string"
              value={formState["username"]}
              name="username"
              onChange={(e) =>
                setFormState({ ...formState, [e.target.name]: e.target.value })
              }
            ></input>
          </div>
        </div>
      </div>
      <div className="mb-4 text-lg">
        <div className="font-Inter font-semibold">Access Code</div>
        <div className="flex">
          <div className="flex-1 flex rounded border border-black">
            <input
              className="p-1 align-middle flex-1 rounded"
              type="string"
              value={formState["accessCode"]}
              name="accessCode"
              onChange={(e) =>
                setFormState({ ...formState, [e.target.name]: e.target.value })
              }
            ></input>
          </div>
        </div>
      </div>
      {(errorMessages.length > 0 || serverSideErrors.length > 0) && (
        <div className="flex mb-4 mt-4 text-lg border-red-500 border p-2 bg-white rounded">
          <div className="flex-1">
            {errorMessages.length > 0 &&
              errorMessages.map((error) => {
                return (
                  <div className="text-red-500" key={error}>
                    * {error}
                  </div>
                );
              })}
            {serverSideErrors.length > 0 && (
              <div className="text-red-500">* {serverSideErrors}</div>
            )}
          </div>
        </div>
      )}
      <div className="flex mb-2">
        <button className="flex-1 eai-btn-grn" type="submit" disabled={isLoading}>
          {isLoading ? "Creating Account..." : "Create Account"}
        </button>
      </div>
    </form>
  );
};

export const ConfirmSignUp = ({
  onSubmit,
  onResendCode,
  userEmail,
  serverSideErrors,
  isLoading = false,
}) => {
  const [confirmationInput, setConfirmationInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(confirmationInput);
  };

  return (
    <form className="p-4" onSubmit={handleSubmit}>
      <div className="text-xl mb-2">We Emailed You</div>
      <div className="text-md mb-2">
        To log in, enter the code we went to {userEmail}. It may take a minute
        or two to arrive.
      </div>
      <div className="mb-2 text-lg">
        <div className="mb-2">Confirmation Code</div>
        <div className="flex">
          <div className="flex-1 flex rounded border border-black">
            <input
              className="p-1 flex-1 rounded "
              type="number"
              value={confirmationInput}
              name="email"
              onChange={(e) => setConfirmationInput(e.target.value)}
            ></input>
          </div>
        </div>
      </div>
      {serverSideErrors.length > 0 && (
        <div className="flex mb-4 mt-4 text-lg border-red-500 border p-2 bg-white rounded">
          <div className="flex-1">
            <div className="text-red-500">* {serverSideErrors}</div>
          </div>
        </div>
      )}

      <div className="flex mb-2">
        <button
          className="transition border flex-1 hover:bg-blue-200 bg-sky-700 hover:text-black text-white rounded-lg p-2"
          type="submit"
          disabled={isLoading}
        >
          {isLoading ? "Confirming..." : "Confirm"}
        </button>
      </div>
      <div className="flex">
        <button
          onClick={onResendCode}
          className="transition border flex-1 hover:bg-blue-200 bg-white text-black rounded-lg p-2"
          type="button"
        >
          Resend Code
        </button>
      </div>
    </form>
  );
};

export const SignIn = ({
  onSubmit,
  serverSideErrors = "",
  onForgotPassword,
  isLoading = false,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassWord] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  useEffect(() => {
    if (serverSideErrors) {
      setErrorMessages(serverSideErrors);
    }
  }, [serverSideErrors]);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    onSubmit({ email, password });
  };

  return (
    <form className="p-4" onSubmit={handleSubmitForm}>
      <div className="mb-2 text-lg">
        <div className="font-Inter font-semibold">Email</div>
        <div className="flex-1 flex rounded border border-black">
          <input
            className="p-1 flex-1 rounded"
            type="email"
            value={email}
            name="email"
            onChange={(e) => setEmail(e.target.value)}
          ></input>
        </div>
      </div>
      <div className="mb-4 text-lg">
        <div className="flex justify-between">
          <div className="font-Inter font-semibold">Password</div>
          <div
            onClick={() => onForgotPassword()}
            className="cursor-pointer font-Inter  text-eai-secondary-blue hover:underline"
          >
            Forgot your password?
          </div>
        </div>
        <div className="flex">
          <div className="flex-1 flex rounded border border-black">
            <input
              className="p-1 align-middle flex-1 rounded-l-lg"
              type={passwordVisible ? "string" : "password"}
              value={password}
              name="password"
              onChange={(e) => setPassWord(e.target.value)}
            ></input>
            <button
              className="p-1 align-middle bg-white rounded-r-lg border-l-2 border-black"
              type="button"
              onClick={() => setPasswordVisible(!passwordVisible)}
            >
              {passwordVisible ? (
                <AiOutlineEyeInvisible fontSize="1.4em" />
              ) : (
                <AiOutlineEye fontSize="1.4em" />
              )}
            </button>
          </div>
        </div>
      </div>
      {errorMessages.length > 0 && (
        <div className="flex mb-4 text-lg border-red-500 border p-2 bg-white rounded">
          <div className="flex-1">
            <div className="text-red-500">
              {errorMessages.length > 0 && `*${errorMessages}`}
            </div>
          </div>
        </div>
      )}
      <div className="flex mb-2">
        <button className="flex-1 eai-btn-grn" type="submit" disabled={isLoading}>
          {isLoading ? "Signing In..." : "Sign In"}
        </button>
      </div>
      <div className="flex mb-2">
        <button
          onClick={() => signInWithRedirect({ provider: "Google" })}
          className="flex-1 transition border hover:bg-red-50 bg-white text-black rounded-lg p-2 border-gray-300 flex items-center justify-center gap-2"
          type="button"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Sign in with Google
        </button>
      </div>
    </form>
  );
};

export const LoggedInDisplay = () => {
  // const { user, signOutMutation } = useGetMe();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const isAdmin = user?.details?.groups?.includes("Admin"); //Mike T check admin for onboarding reset
  const subscriptionsEnabled = process.env.REACT_APP_ENABLE_SUBSCRIPTIONS === "true";
  const { myProfile, myProfileLoaded } = useSelector((state) => state.publicProfile);
  const hasNoPublicProfile = myProfileLoaded && !myProfile;

  useEffect(() => {
    if (user?.permissionDetails?.id) {
      dispatch(fetchMyPublicProfile(user.permissionDetails.id));
    }
  }, [dispatch, user?.permissionDetails?.id]);
  const [signOutLoading, setSignOutLoading] = useState(false);
  const [consentSaving, setConsentSaving] = useState(false);

  const userConsentRaw = user?.permissionDetails?.userConsent;
  const currentConsent = parseUserConsent(userConsentRaw);

  const handleToggleTracking = async () => {
    if (consentSaving || !user?.permissionDetails?.id) return;
    setConsentSaving(true);
    try {
      const newValue = !currentConsent.userTracking;
      const updatedJson = updateConsent(currentConsent, "userTracking", newValue);

      const graphqlClient = generateClient();
      await graphqlClient.graphql({
        query: updateUser,
        variables: { input: { id: user.permissionDetails.id, userConsent: updatedJson } }
      });

      dispatch(setUserConsent(updatedJson));

      if (!newValue) {
        posthog?.reset();
      } else {
        identifyUserForPostHog(posthog, user.permissionDetails.id, {
          email: user.details?.email,
          name: user.details?.username,
          isAdmin: isAdmin ?? false,
          userConsentRaw: updatedJson,
        });
      }
    } catch (error) {
      console.error("Error updating tracking consent:", error);
    } finally {
      setConsentSaving(false);
    }
  };

  //Craig Move this to Redux newhire
  const handleSignOut = async () => {
     if (signOutLoading) return; //prevent multiple clicks
    // CRAIG RESET ALL REDUX STATE
    try {
      setSignOutLoading(true);
      await performSignOut({ posthog });
    } catch (error) {
      console.error("Error signing out", error);
      setSignOutLoading(false);
    }

    //Craig newHire, pending state after moving logout
  };

  const handleChangePassword = () => {
    dispatch(
      setModalState({
        modalOpen: true,
        modalView: modalViewsConst.passwordChange,
        properties: { __modalSize: "sm" },
      })
    );
  };

  //Mike T for onboarding reset for admins only(Test only)
  const handleRestartOnboarding = () => {
    if (!isAdmin) {
      return;
    }
    dispatch(resetOnboarding());
    navigate("/onboarding-v2");
  };

  // Admin-only: clear the new-user tour flags and hard-reload to /home so the full first-run flow (welcome → consent → chat tour) replays from the start.
  const handleRestartTour = async () => {
    if (!isAdmin) {
      return;
    }
    // Await the reset — it's a mutation now, and the reload would abort it in flight.
    const cleared = await clearTourFlags(user?.permissionDetails?.id);
    // Warn loudly: the reload re-fetches the user, so a failed write silently restores the old flags.
    if (!cleared) console.warn("Restart Tour: failed to clear tour flags — the tour may not replay");
    window.location.assign("/home");
  };

  const handleChangeProfilePicture = () => {
    dispatch(setModalState({
      modalOpen: true,
      modalView: modalViewsConst.changeProfilePicture,
      properties: { __modalSize: "sm" },
    }))
  }

  const handleEmailClick = async () => {
    const userId = user?.permissionDetails?.id;
    if (!userId || typeof navigator.clipboard?.writeText !== "function") return;
    try {
      await navigator.clipboard.writeText(userId);
    } catch {
      // Copy failed (permissions / unsupported); keep UI unchanged
    }
  };

  //Craig For now
  if (!user) {
    return false;
  }

  return (
    <PageContainer>
      {/* Settings is a form column, not a grid — it reads better narrower than the page measure */}
      <div className="mx-auto w-full max-w-3xl">
        <PageHeader
          eyebrow="Account"
          title="Settings"
        />

        {user.status === authenticationState.authenticated ? (
          <div className="flex flex-col gap-8">
            {/* Identity — the one block that is about you rather than a list of settings */}
            <section className="eai-panel flex flex-col items-center gap-5 text-center sm:flex-row sm:text-left">
              <ProfilePictureRounded
                onClick={handleChangeProfilePicture}
                testId="settings-profile-picture"
                className="shrink-0 cursor-pointer border border-eai-border transition-colors hover:border-eai-border-hover [--profile-diameter:80px] sm:[--profile-diameter:96px]"
                pictureURL={user?.permissionDetails?.profilePictureUrl}
                diameter={96}
              />
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center justify-center gap-2 sm:justify-start">
                  <h2 className="eai-page-title min-w-0 truncate">{user.details.username}</h2>
                  {isAdmin && <span className="eai-tag-pill-sm shrink-0">Admin</span>}
                </div>
                {/* Clicking the address copies the user id — a support shortcut, not a control */}
                <p className="eai-description-sm mt-1 break-words" onClick={handleEmailClick}>
                  {user.details.email}
                </p>
              </div>
              <button
                type="button"
                onClick={handleChangeProfilePicture}
                className="eai-btn-outline w-full shrink-0 sm:w-auto"
              >
                Change picture
              </button>
            </section>

            <SettingsGroup title="Account">
              <SettingsRow
                title="Change Password"
                description="Update your account password"
                icon={<SettingsIcon aria-hidden className="h-4 w-4 [&_path]:stroke-current" />}
                onClick={handleChangePassword}
              />

              <ManageProfilesSection userId={user?.permissionDetails?.id} />

              <SettingsRow
                title="Public Profile"
                description={
                  <>
                    Choose what details are shown publicly
                    {hasNoPublicProfile && (
                      <span className="font-medium text-eai-danger-text"> — none set up yet</span>
                    )}
                  </>
                }
                icon={<GlobeIcon aria-hidden className="h-4 w-4 [&_path]:stroke-current" />}
                onClick={() => navigate("/home/account/public-profile")}
              />

              {subscriptionsEnabled && (
                <SettingsRow
                  title="Manage Subscriptions"
                  description="View and manage your subscription plans"
                  icon={<LayersIcon aria-hidden className="h-4 w-4 [&_path]:stroke-current" />}
                  onClick={() => navigate("/home/subscriptions")}
                />
              )}
            </SettingsGroup>

            <SettingsGroup title="Privacy">
              <SettingsRow
                title="Usage Analytics"
                description="Allow us to collect anonymous usage data to improve the product experience"
                icon={<ActivityIcon aria-hidden className="h-4 w-4" />}
                trailingBelowSm
                trailing={
                  // A segmented control rather than a bare checkbox — it states both options, and it is the same track the rest of the app switches views with.
                  <div className="eai-seg shrink-0">
                    <button
                      type="button"
                      disabled={consentSaving}
                      onClick={() => !currentConsent.userTracking && handleToggleTracking()}
                      className={`eai-seg-item ${currentConsent.userTracking ? "eai-seg-item-active" : ""}`}
                    >
                      On
                    </button>
                    <button
                      type="button"
                      disabled={consentSaving}
                      onClick={() => currentConsent.userTracking && handleToggleTracking()}
                      className={`eai-seg-item ${!currentConsent.userTracking ? "eai-seg-item-active" : ""}`}
                    >
                      Off
                    </button>
                  </div>
                }
              />
            </SettingsGroup>

            <MyOrganizationList />

            {isAdmin && (
              <SettingsGroup title="Admin Tools">
                <SettingsRow
                  title="Restart Onboarding"
                  description="Replay the onboarding flow from the start"
                  icon={<CompassIcon aria-hidden className="h-4 w-4 [&_path]:stroke-current" />}
                  onClick={handleRestartOnboarding}
                />
                <SettingsRow
                  title="Restart Tour"
                  description="Replay the new-user tour from the start"
                  icon={<TargetIcon aria-hidden className="h-4 w-4 [&_path]:stroke-current" />}
                  onClick={handleRestartTour}
                />
              </SettingsGroup>
            )}

            {/* Sign out closes the page rather than opening another panel, so it stays a slim bar */}
            <div className="flex flex-col items-center gap-3 border-t border-eai-border pt-6 sm:flex-row sm:justify-between">
              <p className="eai-description-sm">
                Signed in as <span className="text-eai-ink">{user.details.email}</span>
              </p>
              <button
                onClick={handleSignOut}
                disabled={signOutLoading}
                className="eai-btn-danger w-full shrink-0 sm:w-auto"
              >
                {signOutLoading ? "Signing Out…" : "Sign Out"}
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </PageContainer>
  );
};

export const ResetPasswordEmailView = ({
  onCancel,
  errorMessages = [],
  onSubmit,
}) => {
  const [email, setEmail] = useState("");

  const handleCancel = (e) => {
    e.preventDefault();
    onCancel();
  };

  const handleSubmitForm = async (e) => {
    e.preventDefault();
    onSubmit(email);
  };

  return (
    <form className="p-4" onSubmit={handleSubmitForm}>
      <div className="mb-2 text-lg">
        <div className="font-Inter font-semibold">Email</div>
        <div className="flex-1 flex rounded border border-black">
          <input
            className="p-1 flex-1 rounded"
            type="email"
            value={email}
            name="email"
            onChange={(e) => setEmail(e.target.value)}
          ></input>
        </div>
      </div>

      {errorMessages.length > 0 && (
        <div className="flex mb-4 text-lg border-red-500 border p-2 bg-white rounded">
          <div className="flex-1">
            {errorMessages.map((errorMessage) => {
              return (
                <div key={errorMessage} className="text-red-500">
                  {`*${errorMessage}`}
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className="flex mb-2">
        <button className="flex-1 eai-btn-grn" type="submit">
          Send Reset Code
        </button>
      </div>
      <div className="flex mb-2">
        <button onClick={handleCancel} className="flex-1 eai-btn" type="cancel">
          Cancel
        </button>
      </div>
    </form>
  );
};

const defaultResetPasswordState = {
  resetCode: "",
  newPassword: "",
  confirmNewPassword: "",
};

export const ResetPassword = ({
  onCancel,
  errorMessages = [],
  resetCodeEmail,
  onSubmit,
}) => {
  const [resetPasswordState, setResetPasswordState] = useState(
    defaultResetPasswordState
  );
  const handleSubmitForm = (e) => {
    e.preventDefault();
    onSubmit(resetPasswordState);
  };

  return (
    <form className="p-4" onSubmit={handleSubmitForm}>
      <div className="mb-2 text-lg">
        <div className="text-sm mb-2">
          A reset code was sent to {resetCodeEmail} . Enter the reset code and
          your updated password.
        </div>
        <div className="font-Inter font-semibold">Reset Code</div>
        <div className="flex-1 flex rounded border border-black">
          <input
            className="p-1 flex-1 rounded"
            value={resetPasswordState.resetCode}
            name="resetCode"
            onChange={(e) =>
              setResetPasswordState({
                ...resetPasswordState,
                resetCode: e.target.value,
              })
            }
          ></input>
        </div>
      </div>
      <div className="mb-2 text-lg">
        <div className="font-Inter font-semibold">New Password</div>
        <div className="flex-1 flex rounded border border-black">
          <input
            className="p-1 flex-1 rounded"
            value={resetPasswordState.newPassword}
            name="newPassword"
            onChange={(e) =>
              setResetPasswordState({
                ...resetPasswordState,
                newPassword: e.target.value,
              })
            }
          ></input>
        </div>
      </div>
      <div className="mb-2 text-lg">
        <div className="font-Inter font-semibold">Confirm Password</div>
        <div className="flex-1 flex rounded border border-black">
          <input
            className="p-1 flex-1 rounded"
            value={resetPasswordState.confirmNewPassword}
            name="confirmNewPassword"
            onChange={(e) =>
              setResetPasswordState({
                ...resetPasswordState,
                confirmNewPassword: e.target.value,
              })
            }
          ></input>
        </div>
      </div>

      {errorMessages.length > 0 && (
        <div className="flex mb-4 text-lg border-red-500 border p-2 bg-white rounded">
          <div className="flex-1">
            {errorMessages.map((errorMessage) => {
              return (
                <div key={errorMessage} className="text-red-500">
                  {`*${errorMessage}`}
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div className="flex mb-2">
        <button className="flex-1 eai-btn-grn" type="submit">
          Reset Password
        </button>
      </div>
      <div className="flex mb-2">
        <button
          onClick={() => onCancel()}
          className="flex-1 eai-btn"
          type="cancel"
        >
          Cancel
        </button>
      </div>
    </form>
  );
};
